var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCasco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.53102 7.1264C6.52006 6.87163 6.52775 6.56482 6.58521 6.26437C6.65172 5.91667 6.77858 5.61 6.98729 5.39361C7.1852 5.18842 7.4911 5.02818 7.99973 5.02818C8.50836 5.02818 8.81432 5.18842 9.01231 5.39364C9.2211 5.61006 9.34803 5.91675 9.41462 6.26446C9.47214 6.56487 9.47991 6.87165 9.46901 7.1264H6.53102Z",
    fill: "#008686"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.07591 17.8961C7.96665 17.8969 7.8574 17.871 7.75969 17.8199L4.58242 16.1761C3.67996 15.708 2.97469 15.1837 2.42397 14.5729C1.21862 13.237 0.548875 11.5222 0.537328 9.74335L0.500022 3.8886C0.496469 3.21288 0.931711 2.60638 1.58369 2.37883L7.41771 0.343902C7.76413 0.221045 8.15052 0.218449 8.50316 0.337846L14.3594 2.3027C15.0149 2.52159 15.4582 3.12377 15.4617 3.79862L15.499 9.6577C15.5106 11.4339 14.863 13.1565 13.6772 14.5062C13.1318 15.1257 12.4328 15.6578 11.5401 16.1337L8.39212 17.8165C8.29353 17.8684 8.18516 17.8952 8.07591 17.8961ZM10.2732 7.1264H10.5893C10.8852 7.1264 11.125 7.36624 11.125 7.66211V11.5907C11.125 11.8865 10.8852 12.1264 10.5893 12.1264H5.41071C5.11485 12.1264 4.875 11.8865 4.875 11.5907V7.66211C4.875 7.36624 5.11485 7.1264 5.41071 7.1264H5.72681C5.71615 6.83607 5.72628 6.47767 5.79595 6.11342C5.87887 5.67988 6.05247 5.20529 6.40892 4.83574C6.77616 4.455 7.30013 4.22461 7.99973 4.22461C8.69934 4.22461 9.22332 4.455 9.59062 4.83571C9.94713 5.20524 10.1208 5.67979 10.2038 6.11333C10.2736 6.47762 10.2838 6.83605 10.2732 7.1264Z",
    fill: "#008686"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCasco);
export default ForwardRef;